import FlexDropdown from '@glu/flex-dropdown/esm';

/**
 * https://jira.us-bottomline.root.bottomline.com/browse/ED-8727
 * fix for the keyboard item selection
 */
FlexDropdown.prototype.doItemSelection = function doItemSelection() {
  if (this.ui.dropdown.hasClass('open')) {
    const $items = this.ui.listItems.find('.item-list .selectable');
    const $selectedItem = $items.filter('.selected');
    const selectedId = $selectedItem.data('value');
    if (this.options.multiSelect) {
      const selector = `[data-value="${selectedId}"]`;

      $selectedItem.find('input:checkbox').trigger('click');
      this.ui.listItems.find('.item-list .selectable').removeClass('selected');
      // Don't lose focus after clicking on item.
      this.ui.listItems.find('.item-list .selectable').filter(selector).addClass('selected');
    } else if (!$selectedItem.hasClass('parent')) {
      this.ui.dropdownWarning.addClass('hide');
      $selectedItem.find('a').trigger('click');
    } else if ($selectedItem.hasClass('parent') && !this.options.disableMultiButton) {
      this.ui.dropdownWarning.addClass('hide');
      this.setSelectedIds(Number(selectedId));
      this.closeDropdown(true);
    } else if (this.options.disableMultiButton) {
      this.ui.dropdownWarning.removeClass('hide');
    }
  }
};

export default FlexDropdown;
export * from '@glu/flex-dropdown/esm';